module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TaskEdit2-1851a618cb8d8c80a811aec127df79bd.jpg";